import useModal from "../../../hooks/useModal";
import { useStore } from "../../../store/useStore";
import CreateReportModal from "./CreateReportModal";
import RoundedCard from "../../../components/RoundedCard/RoundedCard";
import { ReportType } from "../../../store/types/report";
import CalendarSearchIcon from "../../../assets/imgs/CalendarSearch";
import CalendarEditIcon from "../../../assets/imgs/CalendarEdit";
import { Colors } from "../../../utils/constants/style";
import CreateJFWCustomReportModal from "./CreateJFWCustomReportModal";
import CreateDailiesReportModal from "./CreateDailiesReportModal";
import { Flag2, Folder2, Routing, Ticket2 } from "iconsax-react";
import { MoonIcon } from "../../../assets/imgs";
import ShadowBox from "../../../components/ShadowBox/ShadowBox";

const InidividualReports: React.FC<{}> = () => {
  const { pushModal } = useModal();
  const openCreateReportModal = (title: string) => pushModal(<CreateReportModal title={title}/>);
  const openDailiesModal = () => pushModal(<CreateDailiesReportModal />);
  const openJFWCustomHoursReportModal = () => pushModal(<CreateJFWCustomReportModal />);
  const setReportType = useStore((state) => state.report.setReportType);
  const adminData = useStore((state) => state.admin.data);

  return (
    <div className="mt-4">
      <ShadowBox>
        <div>
          <span className="text-lg font-bold text-dark-blue">Clique para fazer download do relatório desejado</span>
          <div className="flex flex-wrap gap-10 mt-10 mb-5">
              <RoundedCard
                onClick={() => { 
                  setReportType(ReportType.MACRO_ALTERED)
                  openCreateReportModal("Relatório de macros com alteração")
                }}
                icon={<CalendarEditIcon width={32} height={32} />}
                title="Macros com Alteração"
                text="Macros que sofreram alteração no período selecionado"
              />
              <RoundedCard
                onClick={() => { 
                  setReportType(ReportType.MACRO_MANUAL)
                  openCreateReportModal("Relatório de macros manuais")
                }}
                icon={<CalendarSearchIcon width={32} height={32} />}
                title="Macros Manuais"
                text="Macros manuais no período selecionado"
              />
              <RoundedCard
                onClick={() => { 
                  setReportType(ReportType.MACRO_INTERJOURNEY)
                  openCreateReportModal("Relatório de descanso interjornada")
                }}
                icon={<MoonIcon width={32} height={32} />}
                title="Descanso Interjornada"
                text="Descanso interjornada realizado no período selecionado"
              />
              <RoundedCard
                onClick={() => { 
                  setReportType(ReportType.LONGEST_WORKING_TIME)
                  openCreateReportModal("Relatório de trabalho ininterrupto")
                }}
                icon={<Flag2 width={24} height={24} color={Colors.white}/>}
                title="Trabalho Ininterrupto"
                text="Maior tempo de trabalho ininterrupto realizado no período selecionado"
              />
              <RoundedCard
                onClick={() => { 
                  setReportType(ReportType.MACROS_LIST)
                  openCreateReportModal("Relatório de lista de macros")
                }}
                icon={<Routing width={32} height={32} color={'white'}/>}
                title="Lista de Macros"
                text="Lista de macros do período selecionado"
              />
            { ['66ec11b94a66048d08c1dec0', '67b4f37f5dc24c1ae7038037', '67603528a2255ac7867f141f'].includes(adminData.company) ?
              <div>
                <RoundedCard
                  onClick={() => { 
                    setReportType(ReportType.DAILIES)
                    openDailiesModal()
                  }}
                  icon={<Ticket2 width={24} height={24} color={Colors.white}/>}
                  title="Diárias"
                  text="Diárias realizadas na competência"
                />
              </div>
              : null
            }
            { adminData.company === '66bb92ee2a8bc6dd7ddd9c27' ?
              <div>
                <RoundedCard
                  onClick={() => { 
                    setReportType(ReportType.JFW_CUSTOM_HOURS)
                    openJFWCustomHoursReportModal()
                  }}
                  icon={<Folder2 width={24} height={24} color={Colors.white}/>}
                  title="Importação JFW"
                  text="Arquivo de importação das horas (Customizado JFW)"
                />
              </div>
              : null
            }
          </div>
        </div>
        
      </ShadowBox>
    </div>
  );
};

export default InidividualReports;
